"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import { ButtonRadialFill } from "@/components/button-radial-fill";
import { COOKIE_CONSENT_MAX_AGE, COOKIE_CONSENT_NAME, type CookieConsentValue, createCookieConsentString, parseCookieConsent } from "@/lib/cookie-consent";
import Cookies from "~/public/assets/cookies.png";
type CookieStoreLike = {
  set: (options: {
    name: string;
    value: string;
    path?: string;
    expires?: Date;
    sameSite?: "lax" | "strict" | "none";
  }) => Promise<void>;
};
export function CookieConsentBanner() {
  const $ = _c(7);
  const [isVisible, setIsVisible] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const storedConsent = parseCookieConsent(document.cookie);
      setIsVisible(storedConsent === null);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = async value => {
      const cookieStore = (window as Window & {
        cookieStore?: CookieStoreLike;
      }).cookieStore;
      if (cookieStore) {
        await cookieStore.set({
          name: COOKIE_CONSENT_NAME,
          value,
          path: "/",
          expires: new Date(Date.now() + COOKIE_CONSENT_MAX_AGE * 1000),
          sameSite: "lax"
        });
      } else {
        document.cookie = createCookieConsentString(value);
      }
      setIsVisible(false);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleConsent = t2;
  if (!isVisible) {
    return null;
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Image src={Cookies} alt="Cookies" className="w-full max-w-5 shrink-0 md:max-w-7" width={100} height={100} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex items-center gap-2.5 md:gap-4.5">{t3}<p className="text-xs text-white/60 md:text-sm">Utilizamos cookies para melhorar sua experiência.{" "}<Link href="/politica-de-privacidade#cookies" className="transition-all duration-300 ease-in-out hover:text-white underline underline-offset-4">Nossa política de cookies</Link></p></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ButtonRadialFill className={"max-md:hidden h-11 w-full max-w-28 rounded-2xl border border-[#484848] px-8\r\n              \t\t\t\t\ttext-sm font-medium text-gray-50 hover:text-white transition-all duration-300 ease-in-out"} classNameFill="bg-white/8" onClick={() => handleConsent("rejected")}>Recusar</ButtonRadialFill>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="pointer-events-none fixed inset-x-0 bottom-0 sm:bottom-10 z-10000"><div className="sm:container mx-auto"><div className="pointer-events-auto mx-auto flex flex-row items-center bg-[#1C1C1C] shadow-2xl max-md:w-full max-md:justify-between max-md:gap-3 max-md:px-4 max-md:py-2.5 md:max-w-fit md:gap-12 md:p-4 md:px-6 lg:gap-18">{t4}<div className="flex shrink-0 gap-3 flex-row md:mx-auto">{t5}<ButtonRadialFill className={"h-9 w-full max-w-24 px-5 text-xs md:h-11 md:max-w-28 md:px-8 md:text-sm rounded-2xl border border-primary-300\r\n              \t\t\t\t\tfont-medium text-primary-300 hover:text-white transition-all duration-300 ease-in-out"} classNameFill="bg-primary-300" onClick={() => handleConsent("accepted")}>Aceitar</ButtonRadialFill></div></div></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}